import React, { Component } from 'react';
import { Button, Dimmer, Icon, Loader, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { IAssignee } from '@relab/alstom-ptw-shared';

import { appState, appStateServerRequests } from '../redux/selectors';
import { ActionType, RootState, ServerRequestStatus } from '../redux/types';
import { assigneeRemoveAction } from '../redux/actions';
import { TranslationComponent } from './TranslationComponent';

interface AssigneeDeleteModalProps {
  projectId: string;
  assignee: IAssignee;
  assigneeRemoveAction: typeof assigneeRemoveAction;
  serverRequest?: ServerRequestStatus;
}

class PAssigneeDeleteModal extends Component<AssigneeDeleteModalProps> {
  state = { modalOpen: false };

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => this.setState({ modalOpen: false });

  handleDelete = () => {
    this.props.assigneeRemoveAction(this.props.projectId, this.props.assignee._id);
  };

  render() {
    const { serverRequest } = this.props;
    let serverRequestFeedback = null;

    if (serverRequest) {
      if (serverRequest.pending) {
        serverRequestFeedback = (
          <Dimmer active inverted>
            <Loader inverted>
              <TranslationComponent stringKey={'Loading'} />
            </Loader>
          </Dimmer>
        );
      } else if (serverRequest.error) {
        serverRequestFeedback = serverRequest.error;
      }
    }

    return (
      <Modal
        trigger={
          <Button icon onClick={this.handleOpen}>
            <Icon name="remove circle" />
          </Button>
        }
        open={this.state.modalOpen}
        onClose={this.handleClose}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          <TranslationComponent stringKey={'Delete Assignee'} />
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>
              <TranslationComponent stringKey={'Are you sure?'} />
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {serverRequestFeedback}
          <Button onClick={this.handleClose}>
            <TranslationComponent stringKey={'Cancel'} />
          </Button>
          <Button color="red" onClick={this.handleDelete}>
            <TranslationComponent stringKey={'Confirm'} />
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  projectId: appState(state).project._id,
  serverRequest: appStateServerRequests(state, ActionType.ASSIGNEE_REMOVE),
});

export const AssigneeDeleteModal = connect(mapStateToProps, { assigneeRemoveAction })(PAssigneeDeleteModal);
